/*========================================================================
* $Id$
*
* Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
*
* Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
* Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
* Urheber festgelegten Stelle in der Funktion des Computerprogramms
* angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
* Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
* Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
* =========================================================================*/

define([
    "underscore"
  ], function (
    _
  ) {

  return {

    delayedThrottled: function (f, wait) {
      var lastArgs,
          timeout,
          that,
          throttled = function () {
            lastArgs = _.toArray(arguments);
            that = this;
            if (timeout) {
              window.clearTimeout(timeout);
            }
            timeout = window.setTimeout(function () {
                f.apply(that, lastArgs);
              }, wait);
          };

      throttled.abort = function () {
        if (timeout) {
          window.clearTimeout(timeout);
        }
      }

      return throttled;
    }
  }

});
